import { render, staticRenderFns } from "./RamoDaniosComponent.vue?vue&type=template&id=3733b474"
import script from "./RamoDaniosComponent.vue?vue&type=script&lang=js"
export * from "./RamoDaniosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports